import styled from 'styled-components';

export const EventPageSubheader = styled.h3`
  font-family: 'Avenir-Demi' !important;
  /* font-weight: 400 !important; */
  font-size: 16px;
  margin: 0;
`;
